var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"navBox"},[_c('div',{on:{"click":function($event){return _vm.linkTo('about-us')}}},[_vm._v("公司介绍")]),_vm._v(" "),_c('div',{on:{"click":function($event){return _vm.linkTo('cooperative-partner')}}},[_vm._v("合作伙伴")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f488021c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MobileAboutNav.vue
// module id = null
// module chunks = 